// src/App.jsx
import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import AdminLogin from './pages/AdminLogin';
import AdminPanel from './pages/AdminPanel';

// Context สำหรับจัดการ Auth State
export const AuthContext = React.createContext({
  isAdminAuthenticated: false,
  setIsAdminAuthenticated: () => {}
});

// Protected Route Component สำหรับ User
function ProtectedRoute({ children }) {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();
  
  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('token');
      setIsAuthenticated(!!token);
      setIsChecking(false);
    };
    
    checkAuth();
  }, []);
  
  if (isChecking) {
    return <div>กำลังตรวจสอบ...</div>;
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  return children;
}

// Protected Route Component สำหรับ Admin
function AdminProtectedRoute({ children }) {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  useEffect(() => {
    const checkAuth = () => {
      const adminToken = localStorage.getItem('adminToken');
      setIsAuthenticated(!!adminToken);
      setIsChecking(false);
    };
    
    checkAuth();
    
    // Listen for storage changes
    window.addEventListener('storage', checkAuth);
    return () => window.removeEventListener('storage', checkAuth);
  }, []);
  
  if (isChecking) {
    return <div>กำลังตรวจสอบ...</div>;
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
}

// Redirect Component สำหรับ User ที่ login แล้ว
function UserRedirect() {
  const [isChecking, setIsChecking] = useState(true);
  const [hasToken, setHasToken] = useState(false);
  
  useEffect(() => {
    const token = localStorage.getItem('token');
    setHasToken(!!token);
    setIsChecking(false);
  }, []);
  
  if (isChecking) {
    return <div>กำลังโหลด...</div>;
  }
  
  if (hasToken) {
    return <Navigate to="/dashboard/pg" replace />;
  }
  
  return <Navigate to="/login" replace />;
}

function App() {
  const [adminAuth, setAdminAuth] = useState(!!localStorage.getItem('adminToken'));

  return (
    <AuthContext.Provider value={{ 
      isAdminAuthenticated: adminAuth, 
      setIsAdminAuthenticated: setAdminAuth 
    }}>
      <Routes>
        {/* ลูกค้าล็อกอิน/สมัคร */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* เมื่อเข้า /dashboard redirect ไป pg */}
        <Route
          path="/dashboard"
          element={<Navigate to="/dashboard/pg" replace />}
        />
        
        {/* Dashboard หลัก รับ :section */}
        <Route
          path="/dashboard/:section"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* Admin ล็อกอิน */}
        <Route path="/admin/login" element={<AdminLogin />} />
        
        {/* หน้าแอดมินหลัก */}
        <Route
          path="/admin"
          element={
            <AdminProtectedRoute>
              <AdminPanel />
            </AdminProtectedRoute>
          }
        />

        {/* กรณี URL อื่นๆ */}
        <Route path="*" element={<UserRedirect />} />
      </Routes>
    </AuthContext.Provider>
  );
}

export default App;